/**
 * Created by mestrad on 2018. 07. 25..
 */

export default Map;
import Style from './Style';
import AjaxRequest from './Ajax';

const $ = jQuery;

function Map(config) {
  var map;
  var markers;
  var polyLayer;
  var drawControl;
  var drawnItems;
  var geoJson = [];
  var layers = [];
  var mapData = {};
  var dataSheetLayerTypeList = [];
  var relatedDataList = [];
  var actualDate;
  var drawLocalOptions = {
    draw: {
      toolbar: {
        actions: {
          title: 'Kilépés',
          text: 'Kilépés',
        },
        finish: {
          title: 'Kész',
          text: 'Kész',
        },
        undo: {
          title: 'Utolsó pont törlése',
          text: 'Utolsó pont törlése',
        },
        buttons: {
          polyline: 'Polyline',
          polygon: 'Polygon',
          rectangle: 'Négyszög',
          circle: 'Kör',
          marker: 'Marker',
          circlemarker: 'Körmarker',
        },
      },
      handlers: {
        circle: {
          tooltip: {
            start: 'Jelölj ki egy területet  a kör rajzolásához.',
          },
          radius: 'Sugár',
        },
        circlemarker: {
          tooltip: {
            start: 'Jelölj ki egy területet  a körmarker elhelyezéséhez.',
          },
        },
        marker: {
          tooltip: {
            start: 'Kattints a marker elhelyezéséhez.',
          },
        },
        polygon: {
          tooltip: {
            start: 'Kattints az alakzat rajzolásához.',
            cont: 'Kattints a rajzolás folytatásához.',
            end: 'Kattints az első pontra a befejezéshez.',
          },
        },
        polyline: {
          error: '<strong>Error:</strong> shape edges cannot cross!',
          tooltip: {
            start: 'Kattints az vonal rajzolásához.',
            cont: 'Kattints a rajzolás folytatásához.',
            end: 'Kattints az utolsó pontra a befejezéshez.',
          },
        },
        rectangle: {
          tooltip: {
            start: 'Jelölj ki egy területet a négyszög rajzolásához.',
          },
        },
        simpleshape: {
          tooltip: {
            end: 'Engedd el az egeret a befejezéshez.',
          },
        },
      },
    },
  };
  var minZoom = 3;

  function init() {
    if (!document.getElementById(config.elementId)) return;
    map = L.map(config.elementId).setView([47.1612, 19.5058], 7);

    setTimeout(function() {
      map.invalidateSize(true);
    }, 300);
    L.tileLayer('https://tile.tracestrack.com/hu/{z}/{x}/{y}.png?key=f9e35bb7b7818a8ffe32e567e29d3a1c', {
      attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
      minZoom: minZoom,
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'your.mapbox.access.token',
    }).addTo(map);
    L.control.fullscreen({
      position: 'topright',
      title: 'Teljes képernyős nézet',
      titleCancel: 'Kilépés a teljes képernyős nézetből',
      content: null,
      forceSeparateButton: true,
      fullscreenElement: false,
    }).addTo(map);
    initSearchFilterEvent();
  }

  function initSearchFilterEvent() {
    $(document.getElementById(config.elementId)).on('filterOn', function(event) {
      removeDrawLayer();
      if (config.type == 'search') {
        drawnItems = new L.FeatureGroup();
        map.addLayer(drawnItems);
        $.extend(L.drawLocal, drawLocalOptions);
        drawControl = new L.Control.Draw({
          draw: {
            polyline: false,
            circlemarker: false,
            circle: true,
            marker: false,
            polygon: false,
          },
        });
        map.addControl(drawControl);
        map.on(L.Draw.Event.DRAWSTART, function() {
          if (polyLayer) {
            drawnItems.removeLayer(polyLayer);
          }
        });
        map.on(L.Draw.Event.CREATED, function(event) {
          polyLayer = event.layer;
          drawnItems.addLayer(polyLayer);
          layers.push(polyLayer);
          $('#' + config.elementId).trigger('change', getDrawCoordinates());
        });
      }
    });
    $(document.getElementById(config.elementId)).on('filterOff', function(event) {
      removeDrawLayer();
    });
  }

  function removeDrawLayer() {
    if (drawControl) {
      drawControl.remove(map);
    }
    if (polyLayer) {
      polyLayer.remove(drawnItems);
    }
  }

  function refresh(data, disableCluster = false) {

    var $map = $('#' + config.elementId);
    $map.removeClass('nnpHidden');

    if (document.getElementById(config.elementId)) {

      if ( ! map ) {
        init();
      } else {
        map.invalidateSize( true );
      }

      if (layers !== undefined) {
        layers.forEach(function(item) {
          if (item !== polyLayer) {
            map.removeLayer(item);
          }
        });
        layers = [];
      }

      if (Array.isArray(data)) {
        if (data[0].nameList == undefined){
          $map.removeClass('smallSizeMap');
        }else{
          $map.addClass('smallSizeMap');
        }
        if (data[0].relatedDataList) {
          relatedDataList = data[0].relatedDataList;
          actualDate = data[0].actualDate;
        }

        mapData = data;
        if (polyLayer) {
          polyLayer.remove(drawnItems);
        }

        markers = L.markerClusterGroup( {
          chunkedLoading:          true,
          disableClusteringAtZoom: disableCluster ? minZoom : 0
        } );
        geoJson = [];

        data.forEach(function(item) {
          if (item.hasOwnProperty('map') && item.map !== null ) {
            if (config.type === 'datasheet' && item.map.coordinates === undefined) {
              var activeLayer = null;
              item.map.layerTypeList.forEach((layer) => {
                if (layer.active) {
                  activeLayer = layer.key;
                }
              });
              if (activeLayer !== null) {
                getData(activeLayer);
              }
            }

            if (item && item.map && item.map.coordinates !== undefined && item.map.coordinates.length > 0) {
              createGeoJson(item);
            }
          } else {
            $map.hide();
          }
        });
        if (geoJson.length > 0) {


          var geoJsonLayer = L.geoJSON(geoJson,
              {
                  weight: 2,
                  fillOpacity: 0.5,
                  fillColor: '#aabbcc',
                  color: '#024680',
                  pointToLayer: function(feature, latlng)
                  {
                      return addMarker(latlng, feature.item);
                  },
                  onEachFeature: (feature, layer) =>
                  {
                    if (feature.content) {
                        layer.bindTooltip(feature.content, { direction: 'center', permanent: true });
                    }
                  },
              }
              ).addTo(markers);



          map.addLayer(markers);
          layers.push(geoJsonLayer);
          layers.push(markers);
          map.fitBounds(geoJsonLayer.getBounds());

          if (config.type === 'datasheet') {
            dataSheetLayerTypeList = mapData[0].map.layerTypeList;
            createLayerControl(geoJsonLayer);

            if (relatedDataList !== undefined) {
              createRelatedDataListLayer();
            }
          }
        }
      }
    }
  }

  function createRelatedDataListLayer() {
    var relatedGeoJson = [];
    relatedDataList.forEach(item => {
      if (item.relatedType !== 'parentList') {
        item.items.forEach(element => {
          if (element.center && element.center.length > 0) {
            element.actualDate = actualDate;
            relatedGeoJson.push({
              item: element,
              type: 'Point',
              coordinates: element.center,
            });
          }
        });
      }
    });
    var geoJsonLayer = L.geoJSON(relatedGeoJson, {
      weight: 2,
      fillOpacity: 0.5,
      fillColor: '#aabbcc',
      color: '#024680',
      pointToLayer: (feature, latlng) => {
        return addMarker(latlng, feature.item);
      },
    });
    markers.addLayers(geoJsonLayer);
    map.addLayer(markers);
    layers.push(geoJsonLayer);
  }

  function createLayerControl(geoJsonLayer) {
    if (dataSheetLayerTypeList.length > 0) {
      var overLayerControls = {};
      dataSheetLayerTypeList.forEach((item) => {
        if (item.active) {
          overLayerControls[item.title] = geoJsonLayer;
        } else {
          var layer = L.geoJSON();
          overLayerControls[item.title] = layer;
        }
      });
      // if(Object.keys(overLayerControls).length > 1){
      //     if(layersControl === undefined){
      //         layersControl = L.control.layers(overLayerControls, null, {position: 'bottomright'}).addTo(map);
      //     }
      //     initLayerChangeEvents();
      // }
    }
  }

  function getData(selectedLayer) {

    var request = {
      url: config.ajaxUrl + '/map',
      data: {
        action: 'map',
        id: mapData[0].id,
        view_date: moment(mapData[0].actualDate).format('YYYY-MM-DD'),
        layer_type: selectedLayer,
      },
      success: function(response) {
        if (response.success && response.data !== undefined) {
          refresh([response.data]);
        }
      },
    };
    AjaxRequest(request);
  }

  function initLayerChangeEvents() {
    map.off('baselayerchange');
    map.on('baselayerchange', (e) => {
      getLayerKey(e.name, (selectedLayer) => {
        if (selectedLayer !== null) {
          getData(selectedLayer);
        }
      });
    });
  }

  function getLayerKey(name, callback) {
    var key = null;
    dataSheetLayerTypeList.forEach((item) => {
      if (item.title === name) {
        key = item.key;
      }
    });
    callback(key);
  }

  function createGeoJson(item) {

    var type = item.map.type;
    var coordinates = item.map.coordinates;
    if (item.map.type === 'Polygon') {
      type = 'MultiPolygon';
    }
    var geoJsonItem = {
      'type': type,
      'coordinates': coordinates,
      'item': item,
    };
    if (item.map.content) {
      $.extend(geoJsonItem, { 'content': item.map.content });
    }

    geoJson.push(geoJsonItem);

    if (type !== 'Point' && config.type !== 'datasheet') {
      addMarker(L.geoJson({ 'type': type, 'coordinates': coordinates }).getBounds().getCenter(), item);
    }
    const reset_map_control = L.Control.extend( {
      options: {
        position: 'topleft'
      }, onAdd( map ) {
        const container = L.DomUtil.create( 'input' );
        container.type = 'button';
        container.title = 'Térkép visszaállítása';
        container.value = '';
        container.className = 'fa-regular';
        container.onclick = () => {
          const bounds = type !== 'Point'
                         ? L.geoJson( geoJsonItem ).getBounds()
                         : L.latLngBounds( [ geoJsonItem.coordinates.slice().reverse() ] );
          map.fitBounds( bounds );
        };
        map.reset_map_control = this;

        return container;
      }
    } );
    if ( ! map.reset_map_control && config.type === 'datasheet' ) {
      map.addControl( new reset_map_control );
      jQuery( '#daddr' ).val( coordinates.slice().reverse() );
    }
  }

  function addMarker(coordinates, item) {

    var activeItem = 0;
    var marker = L.marker(coordinates);

    if (item.nameList) {

      item.nameList.forEach(function(name) {

        //if (map.coordinates != []) {

          activeItem = name;
          activeItem.id = item.id;
          activeItem.actualDate = item.actualDate;

        //}

      });
    }

    if (item.title){
      activeItem = item;
    }

    if (activeItem === undefined) {

      if (item.nameList) {
        activeItem = item.nameList[0];
        activeItem.id = item.id;
        activeItem.actualDate = item.actualDate;

      }

    }

    if (activeItem.title) {
      marker.bindPopup(activeItem.title);
    }

    markers.addLayer(marker);
    initMarkerEvents(marker, activeItem);
    return marker;
  }

  function initMarkerEvents(marker, item) {
    if (!item) return;
    marker.on('click', function(e) {
      let link = jQuery('#resultItem'+item.id).find('a');
      const isMemorial = $('.nnpResultListPlaceholder').hasClass('memorial');
      if (config.type == 'search') {
        window.history.pushState({}, '', link.attr('href'));
        Style.hide($(config.domElements.searchWidget));
        Style.hide($(config.domElements.resultListWidget));
        $(config.domElements.eventHandlerNode).trigger('showDataSheet', [
          {
            id: item.id,
            actualDate: item.actualDate,
            parentSystemType: 0,
          }]);
      } else if (mapData.id !== item.id) {
        window.history.pushState({}, '', link.attr('href'));
        $('#dataSheetManager').trigger('showDataSheet', [
          {
            id: item.id,
            actualDate: item.actualDate,
            parentSystemType: 0,
          }]);
      }
    });
    marker.on('mouseover', function() {
      marker.openPopup();
      $('#resultItem' + item.id).addClass('hoverResultList');
    });
    marker.on('mouseout', function() {
      marker.closePopup();
      $('#resultItem' + item.id).removeClass('hoverResultList');
    });
  }

  function getDrawCoordinates() {
    var bounds = [];
    if (polyLayer instanceof L.Marker) {
      bounds = polyLayer.getLatLng();
      return { bounds: [bounds.lat, bounds.lng] };
    } else if (polyLayer instanceof L.Circle) {
      bounds = polyLayer.getLatLng();
      return {
        bounds: [bounds.lat, bounds.lng],
        radius: polyLayer.getRadius(),
      };
    } else {
      var coordinates = polyLayer.getLatLngs();
      coordinates[0].forEach(function(item) {
        bounds.push([
          item.lat,
          item.lng,
        ]);
      });
      return { bounds: bounds };
    }
  }

  function destroy() {
    $('#searchMap').addClass('nnpHidden');
    map.remove();
  }

  return {
    refresh: refresh,
    destroy: destroy,
  };
}